var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplovinLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_134_3193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512 0H0V512H512V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256 82.3C282.648 82.3 304.25 103.902 304.25 130.55C304.25 143.46 299.169 155.176 290.911 163.835L389.055 334.632C392.8 333.7 396.717 333.2 400.75 333.2C427.398 333.2 449 354.802 449 381.45C449 408.098 427.398 429.7 400.75 429.7C374.102 429.7 352.5 408.098 352.5 381.45C352.5 376.224 353.338 371.194 354.875 366.48C350.856 365.206 345.876 363.761 339.948 362.32C321.155 357.75 292.826 353.08 255.538 353.08C218.253 353.08 189.929 357.75 171.138 362.32C165.608 363.665 160.902 365.013 157.031 366.221C158.623 371.009 159.5 376.127 159.5 381.45C159.5 408.098 137.898 429.7 111.25 429.7C84.6022 429.7 63 408.098 63 381.45C63 354.802 84.6022 333.2 111.25 333.2C114.97 333.2 118.59 333.633 122.068 334.43L220.797 163.533C212.71 154.905 207.75 143.31 207.75 130.55C207.75 103.902 229.352 82.3 256 82.3ZM111.25 362.15C100.591 362.15 91.95 370.791 91.95 381.45C91.95 392.109 100.591 400.75 111.25 400.75C121.909 400.75 130.55 392.109 130.55 381.45C130.55 370.791 121.909 362.15 111.25 362.15ZM400.75 362.15C390.091 362.15 381.45 370.791 381.45 381.45C381.45 392.109 390.091 400.75 400.75 400.75C411.409 400.75 420.05 392.109 420.05 381.45C420.05 370.791 411.409 362.15 400.75 362.15ZM154.086 336.875C157.179 335.994 160.585 335.093 164.297 334.189C185.192 329.109 215.812 324.13 255.538 324.13C295.266 324.13 325.893 329.109 346.789 334.189C350.477 335.086 353.861 335.985 356.939 336.861L265.565 177.848C262.473 178.47 259.275 178.8 256 178.8C252.577 178.8 249.238 178.436 246.016 177.758L154.086 336.875ZM256 111.25C245.341 111.25 236.7 119.891 236.7 130.55C236.7 141.209 245.341 149.85 256 149.85C266.659 149.85 275.3 141.209 275.3 130.55C275.3 119.891 266.659 111.25 256 111.25Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_134_3193"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplovinLogo);
export default __webpack_public_path__ + "static/media/applovin-logo.0f21d7b060a69b8915da661538cebd21.svg";
export { ForwardRef as ReactComponent };